/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IToastOpcoes, Toast } from "../../../Components/Toast/Toast";
import { converterSituacaoProspeccao, IListaProspeccoesDTO, IPropesccoesListDto } from "../../../Dtos/Comercial/Prospeccoes/ProspeccoesDtos";
import ApiService from "../../../Config/ApiConfig";
import { ActionButton, Card, CardActions, CardField, CardView } from "../../../Components/CardView/CardView";
import { Edit } from "lucide-react";
import { credencialTemAcesso } from "../../../Components/Layout/MenuData";
import { Table, TableContainer, Td, Th } from "../../../Components/Table/Table";
import LoadingPage from "../../../Components/Loading/Loading";
import AppLayout from "../../../Components/Layout/Layout";
import { TopActions } from "../../../Components/TopActions/TopActions";
import Pagination from "../../../Components/Pagination/Pagination";

export const ListaProspeccoesPage = () => {
    const navigate = useNavigate()
    const [sd43s, setSd43s] = useState<IPropesccoesListDto[]>([])
    const [filter, setFilter] = useState('');
    const [quantity, setQuantity] = useState('13');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [toastOpcoes, setToastOpcoes] = useState<IToastOpcoes>({ type: "info", visible: false, mensagem: "" })

    useEffect(() => {
        async function checkApi() {
            try {
                const apiService = new ApiService();

                const response = await apiService.get<boolean>("/auth/temAcesso", { params: { tarefa: "Prospecção" } })

                if (!response) {
                    navigate("/home");
                }
            } catch (error) {
                navigate("/home");
            }
        }

        checkApi();
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        buscarProspeccoes()
    }, [currentPage, quantity, filter])

    const buscarProspeccoes = async () => {
        try {
            setLoading(true)

            const apiService = new ApiService();

            const sd01s = await apiService.get<IListaProspeccoesDTO>("/sd43Controller/buscarProspeccoes", {
                params: {
                    currentPage,
                    qtd: quantity,
                    filter: filter
                }
            })
            const pages = Math.ceil(sd01s.count / Number(quantity));

            setSd43s(sd01s.values)
            setTotalPage(pages)

        } catch (error: any) {
            setToastOpcoes({ type: "error", visible: true, mensagem: `Falha ao buscar licenças! \n ${error.response.data}` })
        } finally {
            setLoading(false)
        }
    }

    const handleEdit = (id: number) => {
        navigate("/prospeccao/" + id)
    };

    const btnAddAction = () => {
        navigate("/prospeccao")
    };

    const handleFiltrar = (filtro: string, qtd: string) => {
        setFilter(filtro);
        setQuantity(qtd);
    }

    const closeToast = () => {
        setToastOpcoes({ type: "info", visible: false, mensagem: "" })
    }

    const renderMobileView = () => (
        <CardView>
            {sd43s.map(sd43 => (
                <Card key={sd43.sd43id}>
                    <CardField>
                        <label>Código</label>
                        <span>{sd43.sd43codigo}</span>
                    </CardField>
                    <CardField>
                        <label>CNPJ</label>
                        <span>{sd43.sd43cnpj}</span>
                    </CardField>
                    <CardField>
                        <label>Nome</label>
                        <span>{sd43.sd43nome}</span>
                    </CardField>
                    <CardField>
                        <label>Nome Abreviado</label>
                        <span>{sd43.sd43na}</span>
                    </CardField>
                    <CardField>
                        <label>Situação</label>
                        <span>{converterSituacaoProspeccao(sd43.sd43situacao)}</span>
                    </CardField>
                    <CardActions>
                        <ActionButton onClick={() => handleEdit(sd43.sd43id!)} disabled={!credencialTemAcesso("prospeccao", "sd031acessa")}>
                            <Edit size={16} />
                        </ActionButton>
                    </CardActions>
                </Card>
            ))}
        </CardView>
    );

    const renderDesktopView = () => (
        <TableContainer>
            <Table>
                <thead>
                    <tr>
                        <Th>codigo</Th>
                        <Th>CNPJ</Th>
                        <Th>Nome</Th>
                        <Th>Nome Abreviado</Th>
                        <Th>Situação</Th>
                        <Th>Operações</Th>
                    </tr>
                </thead>
                <tbody>
                    {sd43s.map(sd43 => (
                        <tr key={sd43.sd43id}>
                            <Td>{sd43.sd43codigo}</Td>
                            <Td>{sd43.sd43cnpj}</Td>
                            <Td>{sd43.sd43nome}</Td>
                            <Td>{sd43.sd43na}</Td>
                            <Td>{converterSituacaoProspeccao(sd43.sd43situacao)}</Td>
                            <Td >
                                <ActionButton onClick={() => handleEdit(sd43.sd43id!)} disabled={!credencialTemAcesso("prospecção", "sd031acessa")}>
                                    <Edit size={16} />
                                </ActionButton>
                            </Td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </TableContainer>
    );

    if (loading) {
        return (
            <LoadingPage />
        )
    }

    return (
        <AppLayout>
            <Toast
                isVisible={toastOpcoes.visible}
                message={toastOpcoes.mensagem}
                onClose={closeToast}
                type={toastOpcoes.type}
            />
            <TopActions
                filter={filter}
                quantity={quantity}
                handleAddNew={btnAddAction}
                filtrar={handleFiltrar}
            />
            {isMobile ? renderMobileView() : renderDesktopView()}

            <Pagination
                currentPage={currentPage}
                totalPages={totalPage}
                onPageChange={setCurrentPage}
            />
        </AppLayout>
    );

}